import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "subheader col-6" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "subheader-title" }, "未承認一覧")
], -1)
const _hoisted_4 = { class: "subheader-block ml-auto demo" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "fal fa-download mr-1" }, null, -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-xl-12" }
const _hoisted_9 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "検索条件"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1)
const _hoisted_11 = {
  class: "panel-container show",
  id: "panel-search"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1)
const _hoisted_13 = { class: "panel-content contents" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "請求No", -1)
const _hoisted_16 = { class: "col-md-5 contCnt input-daterange input-group" }
const _hoisted_17 = {
  class: "input-daterange input-group",
  id: "datepicker-5"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-append input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "input-group-text fs-xl",
    style: {"height":"35px"}
  }, "－")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "発行日", -1)
const _hoisted_20 = { class: "col-md-5 contCnt input-daterange input-group" }
const _hoisted_21 = {
  class: "input-daterange input-group",
  id: "datepicker-5"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-append input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "input-group-text fs-xl",
    style: {"height":"35px"}
  }, "－")
], -1)
const _hoisted_23 = { class: "row" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "請求先", -1)
const _hoisted_25 = { class: "col-md-5 contCnt input-group selectedClear radiuszero4right" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "件名", -1)
const _hoisted_27 = { class: "col-md-5 contCnt" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "広告主", -1)
const _hoisted_30 = { class: "col-md-5 contCnt" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "支払期限", -1)
const _hoisted_32 = { class: "col-md-5 contCnt input-daterange input-group" }
const _hoisted_33 = {
  class: "input-daterange input-group",
  id: "datepicker-5"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-append input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "input-group-text fs-xl",
    style: {"height":"35px"}
  }, "－")
], -1)
const _hoisted_35 = { class: "row" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "担当者", -1)
const _hoisted_37 = { class: "col-md-5 contCnt selectedClear" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-xl-12" }
const _hoisted_42 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "案件一覧"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1)
const _hoisted_44 = {
  class: "panel-container show",
  id: "panel-list"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1)
const _hoisted_46 = { class: "panel-content" }
const _hoisted_47 = {
  key: 0,
  class: "gtablecell btnDetCell"
}
const _hoisted_48 = { key: 0 }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { key: 1 }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  key: 1,
  class: "gtablecell btnDetCell text-right"
}
const _hoisted_53 = {
  key: 2,
  class: "gtablecell btnDetCell text-right"
}
const _hoisted_54 = {
  key: 3,
  class: "gtablecell"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_57 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!
  const _component_Or_selectClient = _resolveComponent("Or_selectClient")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-success waves-effect waves-themed",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dl())),
          disabled: _ctx.btnDisable
        }, [
          _hoisted_6,
          _createTextVNode("Excel出力 ")
        ], 8, _hoisted_5)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      name: "start",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.domClaimNo_start) = $event)),
                      onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.getlist(1)), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.domClaimNo_start]
                    ]),
                    _hoisted_18,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      name: "end",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.domClaimNo_end) = $event)),
                      onKeydown: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.getlist(1)), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.domClaimNo_end]
                    ])
                  ])
                ]),
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      class: "form-control",
                      name: "start",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.domClaimDate_start) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.domClaimDate_start]
                    ]),
                    _hoisted_22,
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      class: "form-control",
                      name: "end",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.domClaimDate_end) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.domClaimDate_end]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.delegateClient.items4Client,
                    modelValue: _ctx.domClientid,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.domClientid) = $event)),
                    reduce: (label) => label.c_client_id,
                    label: "c_client_name",
                    style: {"width":"80%"}
                  }, null, 8, ["options", "modelValue", "reduce"]),
                  _createElementVNode("input", {
                    type: "button",
                    class: "btn-primary form-control form-control-sm",
                    value: "検索",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showModalclaim()))
                  })
                ]),
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtKenmei",
                    class: "form-control form-control-sm",
                    maxlength: "200",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.domClaimTitle) = $event)),
                    onKeydown: _cache[10] || (_cache[10] = _withKeys(($event: any) => (_ctx.getlist(1)), ["enter"]))
                  }, null, 544), [
                    [_vModelText, _ctx.domClaimTitle]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtKoukoku",
                    class: "form-control form-control-sm",
                    maxlength: "200",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.domClaimSponsorName) = $event)),
                    onKeydown: _cache[12] || (_cache[12] = _withKeys(($event: any) => (_ctx.getlist(1)), ["enter"]))
                  }, null, 544), [
                    [_vModelText, _ctx.domClaimSponsorName]
                  ])
                ]),
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      class: "form-control",
                      name: "start",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.domClaimPayLimit_start) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.domClaimPayLimit_start]
                    ]),
                    _hoisted_34,
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      class: "form-control",
                      name: "end",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.domClaimPayLimit_end) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.domClaimPayLimit_end]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.delegateStaff.items4staffsSortNum,
                    label: "c_staff_name",
                    modelValue: _ctx.domStaffId,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.domStaffId) = $event)),
                    reduce: (label) => label.c_staff_id
                  }, null, 8, ["options", "modelValue", "reduce"])
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary waves-effect waves-themed btn-search mx-auto",
                  disabled: _ctx.btnDisable,
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.getlist(1)))
                }, " 検索 ", 8, _hoisted_39)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_40, [
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _createElementVNode("div", _hoisted_46, [
              _createVNode(_component_vue_good_table, {
                mode: "remote",
                onPageChange: _ctx.onPageChange,
                onSortChange: _ctx.onSortChange,
                columns: _ctx.columns,
                rows: _ctx.delegate.exitems,
                "sort-options": {
                  enabled: false,
                },
                "pagination-options": {
                  perPageDropdownEnabled: false,
                  enabled: true,
                  jumpFirstOrLast: true,
                  page: 1,
                  perPage: 10,
                  nextLabel: '次へ',
                  prevLabel: '前へ',
                  mode: 'pages',
                  ofLabel: '～',
                  pageLabel: '',
                },
                totalRows: _ctx.delegate.pager.maxcount
              }, {
                "table-row": _withCtx((props) => [
                  (props.column.field == '詳細ボタン')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                        (props.row.c_claim_flag_sales == 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_48, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-block btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/seikyusyocreate?claimnum=' +
                              props.row.c_claim_number,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_49)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_claim_flag_sales == 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_50, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-block btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/seikyusyocreatenotsales?claimnum=' +
                              props.row.c_claim_number,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_51)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (props.column.field == 'c_claim_subtotal')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(_ctx.cnvDetails(props.row.c_claim_subtotal)), 1))
                      : (props.column.field == 'c_claim_total')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_ctx.cnvDetails(props.row.c_claim_total)), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(props.formattedRow[props.column.field]), 1))
                ]),
                _: 1
              }, 8, ["onPageChange", "onSortChange", "columns", "rows", "totalRows"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_errorConf" }, {
      title: _withCtx(() => [
        _hoisted_55,
        _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConf), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_56
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("button", {
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.closeModal4ErrorConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " 確認 ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Or_selectClient, {
      ref: "Mo_modal_selectType",
      evDatas: _ctx.evDatas,
      "onUpdate:evDatas": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.evDatas) = $event))
    }, null, 8, ["evDatas"])
  ]))
}